import { useEffect, useRef } from 'react';
import { trackPerformance } from '../lib/monitoring';

export function usePerformanceMonitoring() {
  const marks = useRef<Map<string, number>>(new Map());

  const startMeasurement = (name: string) => {
    marks.current.set(name, performance.now());
  };

  const endMeasurement = (name: string) => {
    const startTime = marks.current.get(name);
    if (startTime) {
      const duration = performance.now() - startTime;
      trackPerformance(name, duration);
      marks.current.delete(name);
    }
  };

  useEffect(() => {
    // Clean up any lingering measurements
    return () => {
      marks.current.clear();
    };
  }, []);

  return { startMeasurement, endMeasurement };
}